import { Routes } from '@angular/router';
import { landSlugGuard } from 'src/app/common/slug/land-slug.guard';

export const LAND_ROUTES: Routes = [
  { path: '', loadComponent: () => import('./home/land-home.component').then(c => c.LandHomeComponent) },
  {
    path: ':slug',
    loadComponent: () => import('./land.component').then(c => c.LandComponent),
    canActivate: [landSlugGuard],
  },
];
